import React from 'react';
import { 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  SelectChangeEvent 
} from '@mui/material';
import { PromptOption } from '../../types/playground';

const PROMPTS: PromptOption[] = [
  { id: 1, text: "What's the best CRM for startups?", category: 'crm', tags: [] },
  { id: 2, text: "How do I automate onboarding emails?", category: 'onboarding', tags: [] },
  { id: 3, text: "Affordable alternatives to Intercom?", category: 'support', tags: [] },
  { id: 4, text: "Best tools for customer support?", category: 'support', tags: [] },
  { id: 5, text: "How to improve customer retention?", category: 'retention', tags: [] }
];

interface PromptSelectorProps {
  selectedPrompt: PromptOption | null;
  onPromptChange: (prompt: PromptOption) => void;
}

export const PromptSelector: React.FC<PromptSelectorProps> = ({ 
  selectedPrompt, 
  onPromptChange 
}) => {
  const handleChange = (event: SelectChangeEvent<number>) => {
    const prompt = PROMPTS.find(p => p.id === Number(event.target.value));
    if (prompt) onPromptChange(prompt);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <FormControl fullWidth>
        <InputLabel shrink id="prompt-select-label" sx={{ color: '#3B82F6' }}>Select a Prompt</InputLabel>
        <Select
          labelId="prompt-select-label"
          id="prompt-select"
          value={selectedPrompt ? selectedPrompt.id : ''}
          label="Select a Prompt"
          onChange={handleChange}
          sx={{ 
            backgroundColor: '#1E293B',
            color: '#fff',
            '& .MuiSelect-select': { color: '#fff' },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.2)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(148, 163, 184, 0.5)',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3B82F6',
            },
            '& .MuiSelect-icon': {
              color: '#CBD5E1',
            },
          }}
        >
          {PROMPTS.map((prompt) => (
            <MenuItem key={prompt.id} value={prompt.id}>
              {prompt.text}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}; 